import "./loader.css";

export const Loader = ({ fullHeight = false, colorMain = "" }) => {
  return (
    <div className="spinner-container">
      <div style={{ borderTopColor: colorMain }} className={(fullHeight ? "full-height" : "") + "loading-spinner"}></div>
    </div>
  )
}
